import * as React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Drawer,
  Button,
  List,
  Divider,
  ListItem,
  TextField,
} from "@mui/material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import moment from "moment";
import { DirectionsBus, DirectionsCar } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

export default function TemporaryDrawer({ vehicles, url }) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [searchQuery, setSearchQuery] = React.useState("");

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setSearchQuery("");

    setState({ ...state, [anchor]: open });
  };

  const filteredVehicles = vehicles.filter((vehicle) =>
    vehicle.vehicle_no.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
    >
      <TextField
        variant="outlined"
        fullWidth
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search vehicle No"
        style={{ padding: "10px" }}
        sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}
      />
      <Divider />
      <Box sx={{ overflowY: "auto", flexGrow: 1 }}>
        <List
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          {filteredVehicles.map((vehicle, index) => {
            const status =
              moment().diff(vehicle?.last_location_update, "minutes") < 1
                ? "text-green-500"
                : "text-red-500";
            return (
              <ListItem key={index} disablePadding>
                <Link
                  to={`${url}/${vehicle?.vehicle_no}`}
                  style={{ width: "100%" }}
                  className="hover:bg-gray-200"
                >
                  <div className="flex items-center mx-4 mb-2 mt-1">
                    <div className="p-2 bg-gray-100 rounded-full my-2 mr-4 relative">
                      {vehicle?.vehicle_name === "Bus" ? (
                        <DirectionsBus />
                      ) : (
                        <DirectionsCar />
                      )}
                      {/* <FiberManualRecordIcon
                        className={`absolute top-0 right-0 ${status}`}
                        sx={{ fontSize: "12px" }}
                      /> */}
                    </div>
                    <Tooltip title={vehicle?.imei_no}>
                      <p className="">{vehicle?.vehicle_no}</p>
                      <p style={{ fontSize: "12px" }}>
                        {vehicle?.district_name}
                      </p>
                    </Tooltip>
                  </div>
                  <hr />
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Box>
      <Divider />
    </Box>
  );

  return (
    <div>
      <React.Fragment>
        <Button
          onClick={toggleDrawer("right", true)}
          sx={{
            padding: "20px",
            borderRadius: "50%",
            backgroundColor: "#4570EA",
          }}
        >
          <FormatListBulletedIcon sx={{ fontSize: "22px", color: "#fff" }} />
        </Button>
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          sx={{
            "& .MuiDrawer-paper": {
              marginTop: "20px",
              marginBottom: "20px",
              marginRight: "20px",
              borderRadius: "10px",
              height: "95vh",
              scrollbarWidth: "thin",
            },
          }}
        >
          {list("right")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
